import axios from 'axios';

//export const API_URL = 'http://localhost:3003/hoa';
// export const API_URL = 'http://122.165.187.198:3003/hoa';
// export const API_URL = 'https://char-generous-removed-cooler.trycloudflare.com/hoa';
// export const API_URL = 'https://fashion-reserves-administrative-marsh.trycloudflare.com/hoa';
// export const API_URL = 'https://ensures-deutsche-appearance-clock.trycloudflare.com/hoa'; 
export const API_URL = "https://detect-directories-physiology-basename.trycloudflare.com/hoa"
//export const API_URL = 'http://vhoas.com:3003/hoa';
// export const API_URL = 'http://ec2-34-237-242-88.compute-1.amazonaws.com/hoa';


export const getAllStates = () => axios.get(`${API_URL}/state/getAll`);
export const getAllCountries = () => axios.get(`${API_URL}/country/getAll`);
export const getAllEmployees = () => axios.get(`${API_URL}/api/employee/getAll`);


export const addContract = async (newContractData) => {
  try {
    const response = await axios.post(`${API_URL}/api/public/contract/add`, newContractData);
    return response.data;
  } catch (error) {
    console.error('Error adding contract:', error);

    if (!error.response) {
      throw new Error('Network error: Please check your internet connection.');
    }

    const { status, data } = error.response;

    switch (status) {
      case 400:
        throw new Error(`Bad Request: ${data.message || 'Invalid request data.'}`);
      case 401:
        throw new Error('Unauthorized: Please log in.');
      case 403:
        throw new Error('Forbidden: You do not have permission to perform this action.');
      case 404:
        throw new Error('Not Found: The requested resource could not be found.');
      case 500:
        throw new Error('Server Error: Please try again later.');
      default:
        throw new Error(data.message || 'An unknown error occurred.');
    }
  }
};
